import { createSlice } from "@reduxjs/toolkit";

const brandSlice = createSlice({
    name: 'brand',
    initialState: {
        loading: false,
        brand: {},
        isBrandCreated: false,
        isBrandDeleted: false,
        isBrandUpdated: false,
    },
    reducers: {
        brandRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        brandSuccess(state, action) {
            return {
                ...state,
                loading: false,
                brand: action.payload.data
            }
        },
        brandFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        clearError(state, action) {
            return {
                ...state,
                error: null
            }
        },
        clearBrand(state, action) {
            return {
                ...state,
                brand: {}
            }
        },
        newBrandRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        newBrandSuccess(state, action) {
            return {
                ...state,
                loading: false,
                brand: action.payload.brand,
                isBrandCreated: true
            }
        },
        newBrandFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
                isBrandCreated: false
            }
        },
        clearBrandCreated(state, action) {
            return {
                ...state,
                isBrandCreated: false
            }
        },
        deleteBrandRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        deleteBrandSuccess(state, action) {
            return {
                ...state,
                loading: false,
                isBrandDeleted: true
            }
        },
        deleteBrandFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        },
        clearBrandDeleted(state, action) {
            return {
                ...state,
                isBrandDeleted: false
            }
        },
        updateBrandRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        updateBrandSuccess(state, action) {
            return {
                ...state,
                loading: false,
                brand: action.payload.data,
                isBrandUpdated: true
            }
        },
        updateBrandFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        },
        clearBrandUpdated(state, action) {
            return {
                ...state,
                isBrandUpdated: false
            }
        },
    }
});

const { actions, reducer } = brandSlice;

export const {
    brandRequest,
    brandSuccess,
    brandFail,
    clearError,
    clearBrand,
    newBrandFail,
    newBrandSuccess,
    newBrandRequest,
    clearBrandCreated,
    deleteBrandFail,
    deleteBrandRequest,
    deleteBrandSuccess,
    clearBrandDeleted,
    updateBrandFail,
    updateBrandRequest,
    updateBrandSuccess,
    clearBrandUpdated,
} = actions;

export default reducer;
